import {krzysztofJaniszewski} from "../../people/krzysztof_janiszewski";

export const theImportanceOfSleepForMentalHealth = {
    'meta': {
        'title': 'Znaczenie snu dla zdrowia psychicznego | Blog | COLLIGO',
        'description': 'Odkryj kluczową rolę snu w utrzymaniu optymalnego zdrowia psychicznego. Ten przewodnik zagłębia się w naukę snu, jego fazy oraz wpływ na emocje, pamięć i zdolność do uczenia się, dostarczając praktycznych wskazówek i zaleceń dotyczących zdrowego snu.'
    },
    'title': 'Znaczenie snu dla zdrowia psychicznego',
    'date': '2023-09-30',
    'readingTime': 10,
    'author': krzysztofJaniszewski,
    'url': {
        'address': '/blog/znaczenie-snu-dla-zdrowia-psychicznego',
        'title': 'Znaczenie snu dla zdrowia psychicznego | Blog | COLLIGO',
        'name': 'Znaczenie snu dla zdrowia psychicznego'
    },
    'image': {
        'url': '/images/blog/sleep.jpg',
        'width': 886,
        'height': 295,
        'alt': 'Diagnostyka autyzmu'
    },
    'opengraph': {
        'image': {
            'url': null,
            'width': 150,
            'height': 150,
            'alt': 'Odkryj kluczową rolę snu w utrzymaniu optymalnego zdrowia psychicznego. Ten przewodnik zagłębia się w naukę snu, jego fazy oraz wpływ na emocje, pamięć i zdolność do uczenia się, dostarczając praktycznych wskazówek i zaleceń dotyczących zdrowego snu.'
        }
    }
}